var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1844_61545)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.04102,
    y: -3.11719,
    width: 46.2329,
    height: 46.2329,
    fill: "#161C27"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20 21.7306C15.9636 21.7306 12.6914 18.4584 12.6914 14.4219C12.6914 10.3855 15.9636 7.11328 20 7.11328C24.0365 7.11328 27.3087 10.3855 27.3087 14.4219C27.3087 18.4584 24.0365 21.7306 20 21.7306Z",
    fill: "#B0B7C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55661 38.5369C4.26483 29.8164 11.3426 25.3828 19.9694 25.3828C28.7176 25.3828 35.9051 29.5728 36.4405 38.5384C36.4618 38.8955 36.4405 40.0001 35.0679 40.0001C28.2972 40.0001 18.2362 40.0001 4.88468 40.0001C4.42645 40.0001 3.51803 39.0119 3.55661 38.5369Z",
    fill: "#B0B7C3"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M7.99989 23.1092C6.03621 23.1092 4.44434 21.5173 4.44434 19.5536C4.44434 17.5899 6.03621 15.998 7.99989 15.998C9.96357 15.998 11.5554 17.5899 11.5554 19.5536C11.5554 21.5173 9.96357 23.1092 7.99989 23.1092Z",
    fill: "#B0B7C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000579275 31.286C0.345119 27.0436 3.78837 24.8867 7.98519 24.8867C12.2411 24.8867 15.7377 26.9251 15.9981 31.2867C16.0085 31.4605 15.9981 31.9978 15.3304 31.9978C12.0366 31.9978 7.14198 31.9978 0.646669 31.9978C0.423744 31.9978 -0.0181882 31.5171 0.000579275 31.286Z",
    fill: "#B0B7C3"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M31.9999 23.1092C30.0362 23.1092 28.4443 21.5173 28.4443 19.5536C28.4443 17.5899 30.0362 15.998 31.9999 15.998C33.9636 15.998 35.5554 17.5899 35.5554 19.5536C35.5554 21.5173 33.9636 23.1092 31.9999 23.1092Z",
    fill: "#B0B7C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0006 31.286C24.3451 27.0436 27.7884 24.8867 31.9852 24.8867C36.2411 24.8867 39.7377 26.9251 39.9981 31.2867C40.0085 31.4605 39.9981 31.9978 39.3304 31.9978C36.0366 31.9978 31.142 31.9978 24.6467 31.9978C24.4237 31.9978 23.9818 31.5171 24.0006 31.286Z",
    fill: "#B0B7C3"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.924657,
    y: 0.924657,
    width: 38.1507,
    height: 38.1507,
    rx: 19.0753,
    stroke: "#DDE1E9",
    strokeWidth: 1.84931
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1844_61545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupCircle);
export default __webpack_public_path__ + "static/media/group-circle.dd90a4d606c4334e2814fd9160cf335c.svg";
export { ForwardRef as ReactComponent };